import { analytics, useUser } from 'libs';
import Filter from './Filter';
import Toggle from './Toggle';

const options = [{ key: 'preferred', value: 'Favourite Only' }];

interface PreferredLendersFilterProps {
  filters: { preferred?: 0 | 1 | '0' | '1' };
  isPro?: boolean;
  onFilter: (update: { preferred: number | null }) => void;
}

const PreferredLendersFilter = ({ filters, isPro = false, onFilter }: PreferredLendersFilterProps) => {
  const user = useUser();

  if (!user.features.preferred_lenders) {
    return null;
  }

  const hasPreferredLenders = Boolean(user.has_preferred_lenders);
  const needsPreferredLenders = Boolean(user.features.is_pro) && !hasPreferredLenders;
  const isSelected = Boolean(filters.preferred);

  const onChange = () => {
    analytics.productSearch.filter({
      preferred_lenders: isSelected ? 'cleared' : 'selected',
    });

    onFilter({ preferred: isSelected ? null : 1 });
  };

  return (
    <Filter
      name="Favourite lenders"
      isPro={isPro}
      tooltip={
        needsPreferredLenders
          ? 'Mark a lender as favourite using the star on a lender card or profile page to use this filter.'
          : "See only the lenders you've marked as favourite."
      }
    >
      <Toggle
        disabled={needsPreferredLenders && !isSelected}
        isPro={isPro}
        onChange={onChange}
        options={options}
        testId="filter-preferred-lenders"
        value={isSelected ? ['preferred'] : []}
      />
    </Filter>
  );
};

export default PreferredLendersFilter;
